import React, { useState } from 'react'

interface SendMatchingModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (message: string) => void
  recruitmentTitle: string
  enterpriseName: string
  isSubmitting?: boolean
}

const SendMatchingModal: React.FC<SendMatchingModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  recruitmentTitle,
  enterpriseName,
  isSubmitting = false,
}) => {
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (isSubmitting) return

    if (!message.trim()) {
      setError('応募メッセージを入力してください')
      return
    }

    if (message.length < 10) {
      setError('応募メッセージは10文字以上入力してください')
      return
    }

    onSubmit(message)
    setMessage('')
    setError('')
  }

  const handleClose = () => {
    setMessage('')
    setError('')
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* ヘッダー */}
        <div className="p-6 border-b border-main-lightgray">
          <div className="flex items-start justify-between">
            <div>
              <h2 className="text-xl font-bold mb-2">マッチリクエスト</h2>
              <p className="text-sm text-main-darkgray">
                <span className="font-semibold">{enterpriseName}</span>{' '}
                の募集に応募します
              </p>
              <p className="text-xs text-main-darkgray mt-1">
                「{recruitmentTitle}」
              </p>
            </div>
            <button
              onClick={handleClose}
              className="text-main-darkgray hover:text-main-black"
            >
              <span className="material-icons">close</span>
            </button>
          </div>
        </div>

        {/* フォーム */}
        <form onSubmit={handleSubmit}>
          <div className="p-6">
            <div className="mb-4">
              <label htmlFor="message" className="block text-sm font-bold mb-2">
                応募メッセージ <span className="text-main-red">*</span>
              </label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value)
                  setError('')
                }}
                className={`w-full px-3 py-2 border ${
                  error ? 'border-main-red' : 'border-main-lightgray'
                } rounded-lg focus:outline-none focus:ring-2 focus:ring-main-green`}
                rows={6}
                placeholder="貴社の募集内容に興味を持ちました。弊社は..."
              />
              {error && <p className="text-main-red text-sm mt-1">{error}</p>}
              <p className="text-main-darkgray text-xs mt-1">
                10文字以上入力してください
              </p>
            </div>

            <div className="bg-main-lightgreen border border-main-green rounded-lg p-4 mb-4">
              <div className="flex items-start">
                <span className="material-icons text-main-green mr-2">
                  info
                </span>
                <div className="text-sm">
                  <p className="font-semibold text-main-black mb-1">
                    応募前にご確認ください
                  </p>
                  <ul className="text-main-darkgray space-y-1">
                    <li>• 応募後、企業からの返答をお待ちください</li>
                    <li>
                      •
                      マッチングが成立するとメッセージのやり取りが可能になります
                    </li>
                    <li>• 応募内容は後から編集できません</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* フッター */}
          <div className="p-6 border-t border-main-lightgray flex justify-end gap-3">
            <button
              type="button"
              onClick={handleClose}
              disabled={isSubmitting}
              className={`px-6 py-2 text-main-darkgray bg-main-white border border-main-lightgray rounded-lg font-semibold ${
                isSubmitting
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:bg-main-lightgray'
              }`}
            >
              キャンセル
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className={`px-6 py-2 text-white rounded-lg font-semibold flex items-center justify-center gap-2 ${
                isSubmitting
                  ? 'bg-main-darkgray cursor-not-allowed'
                  : 'bg-main-green hover:bg-main-lightgreen'
              }`}
            >
              {isSubmitting && (
                <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
              )}
              {isSubmitting ? '送信中...' : '応募する'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SendMatchingModal
